/**
 * 按新闻时间排序
 */
function rangeData(data) {
    for (var i = 0; i < data.length - 1; i++) {
        for (var j = 0; j < data.length - 1 - i; j++) {
            if (Date.parse(data[j].date) < Date.parse(data[j + 1].date)) {
                var temp = data[j];
                data[j] = data[j + 1];
                data[j + 1] = temp;
            }
        }
    }
    return data;
}

/**
 * 数组分组
 */
function group(source, step) {
    if (source.length == 1) return [source]; //这个情况要单独写一下
    var group = source.reduce((total, current, index) => {
        if (index == 1) {
            //init 第一次 total 是1 current 是 2
            if (step == 1) {
                total = [
                    [total],
                    [current]
                ];
            } else {
                total = [
                    [total, current]
                ];
            }
        } else {
            var last = total[total.length - 1];
            if (last.length < step) {
                last.push(current);
            } else {
                total.push([current]);
            }
        }
        return total;
    });
    return group;
}

export {
    rangeData,
    group
}